import ApiService from '@/services/api.service'

const AttendancesService = {

    delete(id){
      return ApiService.delete(`/Attendances/${id}`)
    },

    update(id,data){
      return ApiService.put(`/Attendances/${id}`,data)
    },

}

  export default AttendancesService;
